import React,{useEffect} from 'react';
import "../css/UpcomingShows.scss"; 
import { Header } from 'semantic-ui-react'
import { Image } from 'semantic-ui-react';
import {store} from "../index"
import {useSelector} from "react-redux"

import divider from "../img/divider.png"

const UpcomingShows = (props) => {
    const contentToRender ={
        us:{
            header:"Upcoming shows",
            content: "No upcoming shows atm"
        },
        pl:{
            header:"Nadchodzące wydarzenia",
            content: "BRAK WYDARZEŃ"
        },
        ru:{
            header:"Предстоящие концерты",
            content: "Нет предстоящих концертов"
        }
    }
    
    const lang = useSelector(  ( state) => state.languageReducer.currentLanguage)
    
    const renderShows = (lang) => {
        
        console.log(`lang`, lang);
        console.log(`contentToRender.lang.header`, contentToRender[lang].header   );
        return(
            <div className="upcoming-shows">
            <Header className="section-header" as="h1"  textAlign="center"  >
                {contentToRender[lang].header} 
                </Header>
            <div>
            <Header size='medium'>{contentToRender[lang].content}</Header>
            </div>
            <Image className="divider-img" src={divider} size='' />
        </div>
        )
    }
    
    console.log(contentToRender.pl.header);
    return (
            <>
            {renderShows(lang)}
            </>
    )
}

export default UpcomingShows
